export default __webpack_public_path__ + "static/media/Active-facility-icon-new.7ffe0d34.svg";